<template>
    <div>
        <section-cafe :content="SectionCafe"/>
       
        <section-program :content="section_program"/>
        <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
        <section-steps :content="section_steps"/>
        </transition>
        <b-container fluid >
            <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
                <section-tecno v-if="show" :content="section_tecno"/>
            </transition>
            <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
                <section-slider :content="section_slider"/>
            </transition>
            <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
                <section-cant-suman class="d-none" v-if="show" :content="section_cant_suman"/>
            </transition>
            <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
                <section-mark class="d-none" v-if="show" :content="SectionMark"/>
            </transition>
            <transition
                    enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutLeft">
                >
                <section-contacto v-if="show" :content="SectionContacto"/>
            </transition>
        </b-container>
    </div>
    <!--<b-container fluid >-->
        <!--<section-cafe :content="SectionCafe"/>-->
        <!--<section-program :content="section_program"/>-->
        <!--<section-tecno :content="section_tecno"/>-->
        <!--<section-slider :content="section_slider"/>-->
        <!--<section-cant-suman :content="section_cant_suman"/>-->
        <!--<section-mark :content="SectionMark"/>-->
        <!--<section-contacto :content="SectionContacto"/>-->
    <!--</b-container>-->
</template>
<script>
    import SectionProgram from '@/components/CommerceInternal/section-program'
    import SectionTecno from '@/components/CommerceInternal/section-tecno'
    import SectionSlider from '@/components/CommerceInternal/section-slider'
    import SectionCantSuman from '@/components/CommerceInternal/section-cant-suman'
    import SectionMark from '@/components/userInternal/section-mark'
    import SectionContacto from '@/components/CommerceInternal/section-contacto'
    import SectionCafe from '@/components/CommerceInternal/section-cafe'
    import SectionSteps from '@/components/CommerceInternal/section-steps'

    export default {
        name: 'CommerceInternal',
        components: {
            SectionProgram,
            SectionTecno,
            SectionSlider,
            SectionCantSuman,
            SectionMark,
            SectionContacto,
            SectionCafe,
            SectionSteps
        },
        data: () => ({
            show: false,
            section_program : {
                titulo: 'Haz tu programa de fidelización más <br> valioso y atractivo',  
                content: 'Somos una plataforma digital de fidelización que tiene todo lo que necesitas para conectarte con tus clientes y hacer crecer tu negocio.',
                imagen: 'gox.png'
            },
            section_steps: {
                titulo: 'Las soluciones que necesitas',
                subtitulo: 'Con la integración a nuestra plataforma obtienes acceso a un conjunto de soluciones <br> flexibles de acumulación de puntos y canje de productos. También, podrás acceder a <br> colecciones exclusivas y a un gran programa de beneficios para tus clientes.',
                blocks: {
                    shops: {
                        titulo: 'Capta y fideliza <br> clientes',
                        subtitulo: 'Atrae nuevos clientes y<br> genera una relación de <br> confianza con ellos.',
                        imagen: 'link.svg',
                        active_line: true,
                        padding_top: 'padding-top: 4rem; margin-bottom: -9rem',
                        class_titulo: 'titulo-col-3'
                    },
                    log: {
                        titulo: 'Acelera tus <br> ingresos',
                        subtitulo: 'Incrementa la venta <br> de tus productos.',
                        imagen: 'statistic.svg',
                        active_line: true,
                        padding_top: 'padding-top: 4rem; margin-bottom: -9rem',
                        class_titulo: 'titulo-col-3'
                    },
                    capta: {
                        titulo: 'Incrementa el consumo <br> de tus clientes',
                        subtitulo: 'Ofrece a tus clientes <br> nuevas formas de ahorrar.',
                        imagen: 'market.svg',
                        active_line: false,
                        padding_top: 'padding-top: 4rem; margin-bottom: -9rem',
                        class_titulo: 'titulo-col-3'
                    }
                }
            },
            section_tecno: {
                titulo: 'Tecnología <br>con atributos',
                content: 'Una vez que seas parte de nuestra plataforma, comienza de inmediato nuestra asociación. Tu negocio contará con un servicio de análisis avanzado y canales digitales móviles y web para hacer crecer tu programa.',
                imagen: 'dispositivos.svg',
                blocks: [
                    {
                        titulo: 'Marketing con data',   
                        imagen: 'bar.svg',
                        content: 'Utilizamos la ciencia de <br> datos y la experiencia en <br> marketing para aprovechar <br> todo el potencial de los<br> programas de fidelización.'
                    },
                    {
                        titulo: 'Seguridad',
                        imagen: 'contrasena.svg',
                        content: 'La protección y <br> seguridad de los datos <br> siempre estarán en el <br> centro de nuestro <br> programa.'
                    },
                    {
                        titulo: 'Innovación de <br>productos',
                        imagen: 'nuevo-producto.svg',
                        content: 'Constante inversión <br> en nuestra área <br> de tecnología.'
                    },
                    {
                        titulo: 'Herramientas <br>faciles de usar',
                        imagen: 'instrumentos.svg',
                        content: 'GOX facilita la conexión <br> con tus clientes, es <br> decir no necesitas ser <br> un experto tecnológico <br> para poder usar y sacar <br> el máximo potencial a <br> nuestra plataforma.'
                        // content: 'Estamos en constante inversión en nuestra área tecnológica, plataforma y productos.'
                    },
                    {
                        titulo: 'Asesoría <br>permanente',
                        imagen: 'asesoria.svg',
                        content: 'Ponemos a tu <br> disposición nuestro <br> equipo de asesores <br> especializado para <br> alcanzar los objetivos <br> de tu negocio.'
                    }
                ]

            },
            section_slider: [
                {
                    titulo: 'Tus clientes <br><strong>amarán GOX</strong>',
                    contenido: 'Con <b>GOX</b>, tus clientes tienen toda la información en un solo lugar, promociones, descuentos y beneficios en la aplicación mas completa y versátil del mercado.  Olvídate de los programas convencionales y las tarjetas físicas, entra al nuevo mundo de <b>GOX</b>.',
                    imagen: 'img1.png',
                    fondo: 'content-yellow.png'
                },
                {
                    titulo: 'No volverán a <br><strong>sentirse solos</strong>',
                    contenido: 'Tus clientes recibirán información importante sobre promociones especiales enviadas directamente a sus teléfonos móviles.',
                    imagen: 'img22.png',
                    fondo: 'content-yellow.png'
                },
                {
                    titulo: '<strong>Recompensas</strong><br> por referir <br> amigos ',
                    contenido: '<b>¡En GOX todos ganamos!,</b> cuando <br> tus clientes refieren a sus amigos <br> viralizando las promociones y <br> descuentos especiales, recibirán <br> puntos gratis y otros beneficios <br> adicionales por su registro y compra.',
                    imagen: 'img33.png',
                    fondo: 'content-yellow.png'
                }
            ],
            section_cant_suman: [
                {
                    titulo: 'Ciudades',
                    total: '4'
                },
                {
                    titulo: 'Usuarios',
                    total: '+100k'
                },
                {
                    titulo: 'Socios',
                    total: '+70'
                }
            ],
            SectionMark: {
                titulo: 'Conoce a nuestros <br>socios <span>GOX</span>',
                class_color: 'mark-gray',
                class_titulo: 'mark-titulo-2',
                socios: [
                    {
                        link: '',
                        image: "socio12.png"
                    },
                    {
                        link: '',
                        image: "socio15.png"
                    },
                    {
                        link: '',
                        image: "socio13.png"
                    },
                    {
                        link: '',
                        image: "socio14.png"
                    },
                    {
                        link: '',
                        image: "socio4.png"
                    },
                    {
                        link: '',
                        image: "socio5.png"
                    },
                    {
                        link: '',
                        image: "socio6.png"
                    },
                    {
                        link: '',
                        image: "socio8.png"
                    },
                    {
                        link: '',
                        image: "socio0.png"
                    },

                    {
                        link: '',
                        image: "socio0.png"
                    },

                    {
                        link: '',
                        image: "socio0.png"
                    },

                    {
                        link: '',
                        image: "socio0.png"
                    },
                    {
                        link: '',
                        image: "socio9.png"
                    }
                ]
            },
            SectionContacto : {
                content: 'Permite que uno de <br> nuestros especialistas te <br> ayude a <strong>crear un plan <br> diseñado para tu negocio.</strong>'
            },
            SectionCafe : {
                texto1: 'Conversemos...',
                texto2: 'Agendemos una <br>reunión',
                texto_formulario: 'Completa este formulario para poder agendar una cita y tomarnos un cafe.'
            }
        }),
        created: function () {
            var self = this;
            setTimeout(() => {
                self.show = true
            }, 10);
        },
        methods: {}
    }
</script>
<style scoped>
</style>